// extracted by mini-css-extract-plugin
var _1 = "CreatePasswordForm-modulehelpText__FlwgB AuthHelpText-moduleAuthHelpText__HX0rS";
var _2 = "CreatePasswordForm-moduletitle__5N9Tf AuthTitle-moduleAuthTitle__VKaTa";
var _3 = "CreatePasswordForm-modulewithNotifications__W0tsp";
export { _1 as "helpText", _2 as "title", _3 as "withNotifications" }
